import { render, staticRenderFns } from "./NoPermissionSection.vue?vue&type=template&id=5db9e1ef&scoped=true&"
import script from "./NoPermissionSection.vue?vue&type=script&lang=js&"
export * from "./NoPermissionSection.vue?vue&type=script&lang=js&"
import style0 from "./NoPermissionSection.vue?vue&type=style&index=0&id=5db9e1ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9e1ef",
  null
  
)

export default component.exports